import { createAction, createAsyncAction } from 'services/actionConfigs';
import { HomeLayoutCode, PREFIX_ACTIONS } from './constants';
import { ICreateCustomerBody, ISettingReferralItem } from './types/customer';
import { IShopAllSetting } from './types/setting';
import { ICategoryItemData, IDeleteProductByIdParams, IDeleteProductsParams } from './types/categories';
import { IProductTaxConfigResData } from './types/tax';
import { IPrintCheckSettingResData } from './types/printCheck';
import { IConsentFormAgreementData } from './types/consentForm';
import { IResponseDataBodyProduct } from 'features/settingService/services/types/product';
import { ICleaningFeeResData, ICleaningFeeResDataV2 } from './types/cleaning-fee';
import { IRoleModuleItem } from './types/role';
import { IPackageProgramItem } from './types/package-program';

const get = {
  categories: createAsyncAction<undefined, ICategoryItemData[]>(PREFIX_ACTIONS + 'getCategories'),
  staffs: createAsyncAction(PREFIX_ACTIONS + 'getStaffList'),
  newStaffs: createAction(PREFIX_ACTIONS + 'getNewStaffs'),
  staffsAvailable: createAsyncAction(PREFIX_ACTIONS + 'staffsAvailable'),
  customers: createAsyncAction(PREFIX_ACTIONS + 'getCustomerList'),
  recentCustomers: createAsyncAction(PREFIX_ACTIONS + 'getRecentCustomerList'),
  shopInfo: createAsyncAction<string>(PREFIX_ACTIONS + 'getShopInfo'),
  specialDiscount: createAsyncAction(PREFIX_ACTIONS + 'getSpecialDiscount'),
  coupons: createAsyncAction(PREFIX_ACTIONS + 'getListCoupon'),
  discountSetting: createAsyncAction<boolean | undefined>(PREFIX_ACTIONS + 'getDiscountSetting'),
  otherPaymentMethod: createAsyncAction(PREFIX_ACTIONS + 'getOtherPaymentMethod'),
  allSetting: createAsyncAction<string | undefined, IShopAllSetting>(PREFIX_ACTIONS + 'getShopAllSetting'),
  productCategories: createAsyncAction(PREFIX_ACTIONS + 'getProductCategories'),
  updateProduct: createAction<IResponseDataBodyProduct>(PREFIX_ACTIONS + 'updateProduct'),
  createProduct: createAction<IResponseDataBodyProduct>(PREFIX_ACTIONS + 'createProduct'),
  productsVIP: createAsyncAction(PREFIX_ACTIONS + 'getProductsVIP'),
  packagePrograms: createAsyncAction<undefined, IPackageProgramItem[]>(PREFIX_ACTIONS + 'getPackagePrograms'),
  totalStation: createAsyncAction<string>(PREFIX_ACTIONS + 'getTotalStation'),
  scheduleBooking: createAsyncAction(PREFIX_ACTIONS + 'getShopScheduleBooking'),
  couponPrint: createAsyncAction<string>(PREFIX_ACTIONS + 'getCouponPrint'),
  feeCreditCard: createAsyncAction(PREFIX_ACTIONS + 'getFeeCreditCard'),
  taxConfig: createAsyncAction(PREFIX_ACTIONS + 'getTaxConfig'),
  productTaxConfig: createAsyncAction<undefined, IProductTaxConfigResData>(PREFIX_ACTIONS + 'getProductTaxConfig'),
  simpleMenu: createAsyncAction<boolean | undefined>(PREFIX_ACTIONS + 'getSimpleMenu'),
  simpleMenuConfigCheckIn: createAsyncAction(PREFIX_ACTIONS + 'getSimpleMenuConfigCheckIn'),
  checkInOnlineLink: createAsyncAction(PREFIX_ACTIONS + 'getCheckInOnlineLink'),
  optionTips: createAsyncAction(PREFIX_ACTIONS + 'getOptionTips'),
  optionTipsAll: createAsyncAction(PREFIX_ACTIONS + 'getOptionTipsAll'),
  quickBookingService: createAsyncAction(PREFIX_ACTIONS + 'getQuickBookingService'),
  staffAvailableBooking: createAsyncAction(PREFIX_ACTIONS + 'getStaffAvailableBooking'),
  printCheckSetting: createAsyncAction<undefined, IPrintCheckSettingResData>(PREFIX_ACTIONS + 'getPrintCheckSetting'),
  settingReferral: createAsyncAction<undefined, ISettingReferralItem[]>(PREFIX_ACTIONS + 'getSettingReferral'),
  agreementConsentForm: createAsyncAction<undefined, IConsentFormAgreementData>(PREFIX_ACTIONS + 'agreementConsentForm'),
  cleaningFee: createAsyncAction<undefined, ICleaningFeeResData>(PREFIX_ACTIONS + 'getCleaningFee'),
  permissionConfig: createAsyncAction<undefined, IRoleModuleItem[]>(PREFIX_ACTIONS + 'getPermissionConfig'),
  cleaningFeeV2: createAsyncAction<undefined, ICleaningFeeResDataV2>(PREFIX_ACTIONS + 'getCleaningFeeV2'),
};

const initShopData = createAction(PREFIX_ACTIONS + 'initShopData');
const getNewCategories = createAsyncAction(PREFIX_ACTIONS + 'getNewCategories');
const getCategoriesWithoutBE = createAsyncAction(PREFIX_ACTIONS + 'getCategoriesWithoutBE');
const resetCouponBillPrint = createAction(PREFIX_ACTIONS + 'resetCouponBillPrint');
const changeHomeLayout = createAction<HomeLayoutCode>(PREFIX_ACTIONS + 'changeHomeLayout');
const doInit = {
  checkIn: createAction(PREFIX_ACTIONS + 'initCheckInShopData'),
  editTicket: createAction(PREFIX_ACTIONS + 'initEditTicketShopData'),
};

const doAdd = {
  customer: createAsyncAction<ICreateCustomerBody>(PREFIX_ACTIONS + 'doAddNewCustomer'),
};

const deleteProducts = createAction<IDeleteProductsParams>(PREFIX_ACTIONS + 'deleteProducts');
const deleteProductById = createAction<IDeleteProductByIdParams>(PREFIX_ACTIONS + 'deleteProductById');

const shopActions = {
  get,
  initShopData,
  getNewCategories,
  getCategoriesWithoutBE,
  doInit,
  doAdd,
  resetCouponBillPrint,
  changeHomeLayout,
  deleteProducts,
  deleteProductById,
};

export default shopActions;
